export default __webpack_public_path__ + "static/media/Olympus Logo.79e4d282.svg";